<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="物流单号" name="logistics_number"></c-form-item>
					<c-form-item type="input" label="客户手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
					<!-- <c-form-item type="input" label="业务员姓名" name="salesman_realname"></c-form-item> -->
					<c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="receiving_phone"></c-form-item>
                    <c-form-item type="input" label="交付门店" name="service_center" placeholder="模糊匹配,支持门店名称、联系人信息搜索"></c-form-item>
					<c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
					<!-- <c-form-item type="checkbox" label="订单类型" name="order_type" :options="orderType"></c-form-item> -->
					<c-form-item type="checkbox" label="销售方式" name="order_classify" :options="orderClassify"></c-form-item>
				</c-form>
			</m-search>
			<c-table ref="table">
				<c-table-column
					width="400"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="数量"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="总金额"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="操作"
					width="170"
					align-center
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<!-- <c-checkbox></c-checkbox> -->
								<div v-if="data.present_level_name" class="tag" style="background:red">赠送会员【{{data.present_level_name}}】</div>
								<span class="number">订单号：{{data.order_number}}</span>
								<div v-if="data.order_classify ==2" class="tag" style="background: #B232FE">直销</div>
								<div v-else class="tag" style="background: #0066F1">供货</div>
								<p class="info">买家：{{data.user_manage_mobilephone}}
									<span v-if="data.nick_name">({{data.nick_name}})</span>
								</p>
								<p class="info">
									下单时间：{{data.create_date}}
								</p>
								<p class="info" v-if="data.payment_state == 3 && data.payment_date">
									支付时间：{{data.payment_date}}
								</p>
                                <p class="info" v-if="data.service_center">
                                    交付门店：{{data.service_center}}
                                </p>
							</div>
						</div>
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<span class="number">
									收货信息：{{data.receiving_name}}；{{data.receiving_phone}}；{{data.receiving_address}}
								</span>
							</div>
						</div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-image class="sku-image" :src="sku.product_img_url"></c-image>
										<div class="flex-grow">
											<p class="sku-name ellipsis">{{sku.product_name}}</p>
											<p class="sku-sku">{{sku.product_sku_spec}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
								</div>
							</div>
							<div class="order-sum flex-column flex-center">
								<span v-if="data.order_type==2 && data.payment_state == 1">
									{{data.product_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.payment_state != 1">
									{{data.payment_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.logistics_money > 0">
									(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.payment_state != 3">
									￥{{parseFloat(data.product_money+data.custom_money +data.logistics_money + data.total_fee_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.payment_state == 3">
									￥{{parseFloat(data.payment_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.logistics_money > 0" >
									(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
									(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
									(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
								</span>
							</div>
							<div class="order-state flex-column flex-center">
								<span v-if="data.check_state==1 && data.payment_type=='银行转账'" style="color:#182eff">待审核</span>
								<span v-if="data.check_state==3" style="color:#ff5555">审核驳回</span>
								<span v-if="data.check_state==2">
									{{orderStateName[data.order_state]}}
									<span v-if="data.return_flag==1">(售后中)</span>
									<span v-else-if="data.refund_flag==1">(未发退款中)</span>
								</span>
								<span v-if="data.order_state == 3">({{data.deliver_state}})</span>
								<a @click="navigateTo(`/order_detail/${data.order_number}`)">订单详情</a>
							</div>
							<div class="order-handle flex-column flex-center">
								<c-button color="gray" hollow v-if="data.check_state==1 && data.order_state != 6" @click="navigateTo(`/order_detail/${data.order_number}`)">审批</c-button>
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import {mapState} from 'vuex'
	export default {
		name: 'm_order_apply',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			productInfo
		},

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
          return {
            is_bath:0,
            text_msg:'',
            orderDetail: {},
            orderNumber: '',
            sendList: [],
            sendNum: {},
            orderStateName: {
              1: '待付款',
              2: '待发货',
              3: '待收货',
              5: '交易完结',
              6: '已关闭'
            },
            orderModeName: {
              1: '平台自营',
              2: '商家自营'
            },
            orderTypeName: {
              1: '普通',
              2: '积分',
              3: '赠品',
              4: '砍价',
              5: '预定全款',
              6: '预定定金',
              7: '定制',
              18: '搭配购',
              19: '一元购',
              99: '微信小店'
            },
            orderClassifyName: {
              1: '供货',
              2: '直销'
            },
            orderSourceName: {
              'OMS':'管理后台',
              'IOS': '苹果',
              'ANDROID': '安卓',
              'MINI': '小程序',
              'PC': 'PC电脑'
            },
            orderState: [{
                name: '待付款',
                value: 1
              },{
                name: '待发货',
                value: 2
              },{
                name: '待收货',
                value: 3
              },{
                name: '交易完结',
                value: 5
              },{
                name: '已关闭',
                value: 6
              }
            ],
            checkState: [{
                name: '待审核',
                value: 1
              },{
                name: '审核通过',
                value: 2
              },{
                name: '审核不通过',
                value: 3
              }
            ],
          }
        },

        computed: {
			...mapState(['systemConfig']),
          orderClassify(){
            return ([{
              name:'供货',
              value: 1
            },{
              name:'直销',
              value: 2
            }]);
          },
          orderType() {
            return (
              [{
                name: '普通',
                value: 1
              },{
                name: '赠品',
                value: 3
              }].concat(this.systemConfig.points_system == 'ON'?[{
                name: '积分',
                value: 2
              }]:[])
              .concat(this.systemConfig.bargain_enabled == 'ON'?[{
                name: '砍价',
                value: 4
              }]:[])
              .concat(this.systemConfig.presell_enabled == 'ON'?[{
                name: '预定全款',
                value: 5
              }]:[])
              .concat(this.systemConfig.presell_enabled == 'ON'?[{
                name: '预定定金',
                value: 6
              }]:[])
              .concat(this.systemConfig.product_custom == 'ON'?[{
                name: '定制',
                value: 7
              }]:[])
            );
          },
          defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
			//搜索
			searchHandle(data) {
				data.stationed_type = 1;
				//查询类型（1：普通查询，2：查询待审核的订单）
				data.queryApply = 2;
				data.check_state = [1];
				this.searchDate = data;
				this.$refs.table.load({
					url: '/order/detail_list',
					data
				});
			}
			
		}
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.order {
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.tag {
				border-radius: 2px;
				padding: 0 5px;
				margin-left: 6px;
				line-height: 18px;
				color: #fff;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 660;
			flex-basis: 660px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 400;
					flex-basis: 400px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 170;
			flex-basis: 170px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			padding: 10px 0;
			
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>